export default {
  ShowTransfer: 'ShowTransfer',
  ShowCAReceipt: 'ShowCAReceipt',
  Save: 'Save',
  SaveAdd: 'SaveAdd',
  SaveClose: 'SaveClose',
  TransferPostedAccount: 'TransferPostedAccount',
  // Hoãn
  Postpone: 'Postpone',
  NextVoucher: 'NextVoucher',
  BackVoucher: 'BackVoucher',
  SaveView: 'SaveView',
  Ok: 'Ok',
  Delete: 'Delete',
  All: 'All',
  Follow: 'Follow',
  Unfollow: 'Unfollow',
  Active: 'Active',
  Unactive: 'Unactive',
  Edit: 'Edit',
  Duplicate: 'Duplicate',
  Add: 'Add',
  Approve: 'Approve',
  Reject: 'Reject',
  View: 'View',
  Posted: 'Posted',
  UnPosted: 'UnPosted',
  Estimate: 'Estimate',
  NextStep: 'NextStep',
  BackStep: 'BackStep',
  ViewAccount: 'ViewAccount',
  ViewQuantity: 'ViewQuantity',
  AddAutoBusiness: 'AddAutoBusiness',
  GenerateData: 'GenerateData',
  GenerateCaPaymentSalary: 'GenerateCaPaymentSalary',
  Refresh: 'Refresh',
  ChangeStatusPosted: 'ChangeStatusPosted',
  Copy: 'Copy',
  GLVoucherDetail: 'GLVoucherDetail',
  SaveParalell: 'SaveParalell',
  InsertRowGrid: 'InsertRowGrid',
  DeleteRowGrid: 'DeleteRowGrid',
  PostponeParalell: 'PostponeParalell',
  Cancel: 'Cancel',
  SettingAccount: 'SettingAccount',
  Import: 'Import',
  SaveApprove: 'SaveApprove',
  // Gửi phê duyệt
  SendApproval: 'SendApproval',
  Quit: 'Đóng',
  Print: 'Print',
  // Bảng kê
  BUVoucherListPlanned: 'BUVoucherListPlanned',
  BUVoucherListNotPlanned: 'BUVoucherListNotPlanned',
  BUVoucherListReceipExpense: 'BUVoucherListReceipExpense',
  BUVoucherListRealExpense: 'BUVoucherListRealExpense',
  BUVoucherListOther: 'BUVoucherListOther',

  // Nhập số dư
  AccountBalance: 'AccountBalance',
  // Đóng thuế
  PayTax: 'PayTax',

  InvolveVoucher: 'InvolveVoucher', // Chứng từ liên quan

  RestoreBackup: 'RestoreBackup', // PHục hồi sao lưu

  CopyVoucher: 'CopyVoucher', // Copy chứng từ

  //#region Nhận báo cáo cấp dưới
  ReceiveReport: 'ReceiveReport',
  SendRequest: 'SendRequest',
  //#endregion

  RegenerateData: 'RegenerateData', // Tạo lại dữ liệu

  CopyVoucherOther: 'CopyVoucherOther', // Copy chứng từ từ popup

  //#region Báo cáo
  ViewReport: 'ViewReport',
  CreateReport: 'CreateReport',
  SubmitReport: 'SubmitReport',
  RetrieveReport: 'RetrieveReport',
  ReCreateReport: 'ReCreateReport',
  SummarizeReport: 'SummarizeReport',
  CancelSummarizeReport: 'CancelSummarizeReport',
  ExportReport: 'ExportReport',
  GetData: 'GetData',
  //#endregion

  //#region Biên lai
  SyncTicket: 'SyncTicket',
  CheckReplacedTicket: 'CheckReplacedTicket',
  MarkPosted: 'MarkPosted',
  UnmarkPosted: 'UnmarkPosted',
  //#endregion

  //#region Kết nối nền tảng số
  RejectPayment: 'RejectPayment',
  SendFPT: 'SendFPT',
  ConnectDVCMultiBudgetCode: 'ConnectDVCMultiBudgetCode',
  //#endregion

  //#region Kho bạc điện tử
  CheckKBNNStatus: 'CheckKBNNStatus',
  //#endregion

  //#region Hệ thống
  ChangeExecutor: 'ChangeExecutor',
  CheckValidAmount: 'CheckValidAmount',
  ImportData: 'ImportData',
  CreateDatabase: 'CreateDatabase',
  BackupData: 'BackupData',
  RestoreData: 'RestoreData',
  CloseLedger: 'CloseLedger',
  ReopenLedger: 'ReopenLedger',
  SaveSignature: 'SaveSignature',
  ExportAccessHistory: 'ExportAccessHistory',
  //#endregion

  //#region Ký số
  SendSignRequest: 'SendSignRequest',
  Sign: 'Sign',
  RejectSign: 'RejectSign',
  AddSigner: 'AddSigner',
  CompleteSign: 'CompleteSign',
  DeleteSignRequest: 'DeleteSignRequest',
  //#endregion

  //#region Kiểm kê
  AdjustInventory: 'AdjustInventory',
  CancelAdjustInventory: 'CancelAdjustInventory',
  //#endregion
};
